class BrixPasswordMessageBar {
  static init(...parameters) {
    return new BrixPasswordMessageBar(...parameters);
  }

  constructor(block) {
    this.block = block;
    if (window.sessionStorage.getItem('new_user_password')) {
      this.block.classList.add('-visible');
      window.sessionStorage.removeItem('new_user_password');
    }

    this.closeButton = this.block.querySelector('button');
    if (this.closeButton) {
      this.closeButton.addEventListener('click', () => {
        this.block.classList.remove('-visible');
      });
    }
  }
}
// Register class
if (window.brix && window.brix.registerBlock) {
  window.brix.registerBlock('brix-password-message-bar', BrixPasswordMessageBar.init);
}
